<template>
  <new-text-input
    :name="name"
    :label="label"
    :api-errors="apiErrors"
    :help-text="helpText"
    type="password"
    input-mode="numeric"
    autocomplete="off"
    :autofocus="autofocus"
    :rules="rules"
  />
</template>

<script setup lang="ts">
import NewTextInput from '@/components/shared/forms/NewTextInput.vue';
import { computed } from 'vue';
import { TranslateResult } from 'vue-i18n';

const props = withDefaults(
  defineProps<{
    name?: string;
    label?: TranslateResult | string;
    helpText?: string;
    required?: boolean;
    checkStrength?: boolean;
    autofocus?: boolean;
    apiErrors?: Record<string, unknown>;
  }>(),
  {
    name: 'pin',
    label: '',
    helpText: '',
    required: true,
    checkStrength: false,
    autofocus: false,
    apiErrors: () => ({}),
  },
);

const rules = computed(() =>
  [
    ...(props.required ? ['required'] : []),
    'numeric',
    'length:6',
    ...(props.checkStrength ? ['strongPin'] : []),
  ].join('|'),
);
</script>
